import { Box, Button, FormControlLabel, Paper, Radio, RadioGroup, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useZohoAuthContext } from "context/ZohoAuthContext";
import { useCalenderConfig } from "hook/use-calender-config";
import { enqueueSnackbar } from "notistack";
import React, { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { zohoApi } from "zohoApi";

const calenderViewOptions = [
  { label: "Day", value: "day" },
  { label: "Week", value: "week" },
  { label: "Month", value: "month" },
];

export const SettingsCalender = () => {
  const context = useZohoAuthContext();
  const { calenderConfig, isPending } = useCalenderConfig();
  const queryClient = useQueryClient();
  const { orgId, apiKey, dataCenterUrl } = context;

  const { mutate } = useMutation({
    mutationKey: ["update-calender-config"],
    mutationFn: async (data) => {
      const { data: respData } = await zohoApi.config.upsertConfigToDB({
        orgId,
        apiKey,
        dataCenterUrl,
        settingId: data?.setting_id,
        settingApiName: "calenderConfig",
        settingSchema: data,
      });

      return respData;
    },
    onSuccess: (data) => {
      if (data?.data?.setting_id) {
        queryClient.invalidateQueries({ queryKey: ["calenderConfig"] });
        enqueueSnackbar("Successfull", { variant: "success" });
      }
    },
  });

  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { dirtyFields },
    reset,
  } = useForm({
    defaultValues: {
      setting_id: calenderConfig?.setting_id || "",
      calenderView: calenderConfig?.calenderView || calenderViewOptions[0].value,
      // setting_id: "",
      // calenderView: savedSetting?.calenderView ?? calenderViewOptions[0],
    },
  });

  useEffect(() => {
    if (calenderConfig) {
      reset(calenderConfig);
    }
  }, [calenderConfig, reset]);

  const onSubmit = async (data) => {
    // return;
    mutate(data);
  };
  return (
    <Box sx={{ mb: ".5em" }} component="form" onSubmit={handleSubmit(onSubmit)}>
      <Paper>
        <Typography
          sx={{
            // bgcolor: "rgba(199, 199, 199, 0.5)",
            p: ".5em",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            mb: ".5em",
            bgcolor: "primary.main",
            color: "primary.contrastText",
          }}
        >
          Calender Settings
        </Typography>
        <Box sx={{ pl: "1rem", py: ".25rem", pr: ".25rem" }}>
          <Typography
            component="label"
            htmlFor="all-day"
            sx={{ color: "text.secondary", display: "inline-flex", alignItems: "center", mr: "1rem" }}
          >
            Calender View
          </Typography>
          <Controller
            name="calenderView"
            control={control}
            render={({ field }) => (
              <RadioGroup
                {...field}
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="calender-view-buttons-group"
                onChange={(e, value) => {
                  field.onChange(value);
                }}
              >
                {calenderViewOptions.map((option) => (
                  <FormControlLabel
                    value={option.value}
                    control={
                      <Radio
                        sx={{
                          "& .MuiSvgIcon-root": {
                            fontSize: 20,
                          },
                        }}
                      />
                    }
                    label={option.label}
                  />
                ))}
              </RadioGroup>
            )}
          />
        </Box>
        <Box sx={{ pl: "1rem", py: ".25rem", pr: ".25rem", display: "flex", justifyContent: "end" }}>
          <Button
            variant="contained"
            size="small"
            sx={{ textTransform: "capitalize" }}
            type="submit"
            disabled={watch("calenderView") === calenderConfig?.calenderView}
          >
            Save
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};
